module.exports = __webpack_public_path__ + "static/glasses-b2d65397d2d6710ae5a456f645b444d8.png";